import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';

import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { BrandEnum, RegStatusEnum, ScoreFlagTypeEnum } from 'src/app/core/dtos/enum';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { RegistrationService } from 'src/app/core/services/registration.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-my-test-registration]',
  templateUrl: './my-test-registration.component.html',
  styleUrls: ['./my-test-registration.component.scss']
})
export class MyTestRegistrationComponent implements OnInit {

  @ViewChild('content') modalContent: string;
  @Input() reg: UserAccountRegDto;
  @Input() brandId: BrandEnum;
  @Input() regPoliciesUrl: string;
  @Input() testDayInfoUrl: string;
  @Output() confirmEmail = new EventEmitter<UserAccountRegDto>();
  brandName: string;
  fileName: string;
  regId: number;
  phoneNumber: string;
  caelCETestTypeId = 10;
  complaintSubmissionDate: Date;
  reevaluationSubmissionDate: Date;
  localTimeZone: string;
  testDate: Date;

  constructor(
    private configHelper: ConfigHelper,
    private accountService: AccountService,
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private router: Router,
    private modalService: NgbModal,
    private dateTimeHelper: DateTimeHelper
  ) { }

  ngOnInit(): void {
    this.brandName = this.configHelper.getBrandName();
    this.phoneNumber = this.brandId === BrandEnum.CELPIP ? "1-800-958-5186" : "1-855-520-2235";
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.reevaluationSubmissionDate = this.reg.userAccountReevaluationRequest?.reevaluationOrderCreatedDate ? this.convertUTCDateToLocalDate(new Date(this.reg.userAccountReevaluationRequest.reevaluationOrderCreatedDate)) : null;
    if (this.brandId === BrandEnum.CELPIP) {
      this.checkScoreFlags(this.reg.regId);
    }
    const testDateUtcToLocal = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(this.reg.testDateTimeUtc));
    this.testDate = this.reg.isWebDelivery ? testDateUtcToLocal : this.reg.testDateTime;
  }

  checkScoreFlags(regId: number) {
    this.registrationService.getRegScoreFlags(regId)
      .subscribe(
        result => {
          const selfReportingScoreFlag = result.content.filter(r => r.flagTypeId === ScoreFlagTypeEnum.TestTakerComplaint)[0];
          if (selfReportingScoreFlag?.dateCreatedUtc) {
            this.complaintSubmissionDate = this.convertUTCDateToLocalDate(new Date(selfReportingScoreFlag.dateCreatedUtc));
          }
        }
      );
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  public get RegStatusEnum() {
    return RegStatusEnum;
  }

  convertUTCDateToLocalDate(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  downloadScoreReportUrl(reg: UserAccountRegDto) {
    if (reg.regStatusEnum === RegStatusEnum.ScoreInvalidated) {
      this.toastService.warning(`The test scores for this ${this.brandName} registration number have been invalidated by Paragon Testing Enterprises. For more information, please contact Paragon at ${this.phoneNumber}.`);
      return;
    }

    if (this.brandId === BrandEnum.CELPIP) {
      this.router.navigate([`/account/check-score/${reg.regId}`]);
      return;
    }
    this.accountService.getScoreReportFilename(reg.regId)
      .subscribe(
        result => {
          this.regId = reg.regId;
          this.fileName = result.content;
          this.modalService.open(this.modalContent);
        },
        () => {
          this.toastService.warning("Unable to download score.");
        });
  }

  hideAndDownload() {
    this.accountService.downloadScoreReport(this.fileName)
      .subscribe(
        res => {
          const dataType = res.type;
          const blob = new Blob([res], { type: dataType });
          const data = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = data;
          downloadLink.setAttribute('download', this.fileName);
          downloadLink.click();
          this.modalService.dismissAll();
        },
        () => {
          this.toastService.warning('Unable to download score');
        }
      );
  }

  resendEmail(reg: UserAccountRegDto) {
    this.confirmEmail.emit(reg);
  }

}
